import React, {FC} from "react";
import Link from "next/link";
import classNames from "classnames";
import defaultImage from "../../images/defaultpic.webp";
import {IBlogDataPost} from "../../types/pages";
import cls from "./shared.module.scss"
import Image from "next/image";
import {domainUrl} from "../../helper";
import {createRightDate} from "../../services/utils";
import {TranslationsType} from "../../types/homePageTypes";

interface IProps {
    post: IBlogDataPost,
    dbName?: string,
    layout: {
        [key: string]: string
    },
    forBLogType?: string,
    domain: string,
    translationsData: TranslationsType
}

const PostCard: FC<IProps> = ({
                                  post,
                                  layout,
                                  domain,
                                  dbName,
                                  forBLogType,
                                  translationsData
                              }) => {

    const cardClasses = classNames(cls["post-card"], {
        [cls["post-card--layout--grid"]]: ["grid-nl", "grid-lg"].includes(layout.classic),
        [cls["post-card--layout--list"]]: ["list-nl", "list-sm"].includes(layout.classic),
        [cls["post-card--size--nl"]]: ["grid-nl", "list-nl"].includes(layout.classic),
        [cls["post-card--size--lg"]]: layout.classic === "grid-lg",
        [cls["post-card--size--sm"]]: layout.classic === "list-sm",
    });

    const trueImageUrl = post.image ? domainUrl(`${dbName}/storage/${domain}/${post.image}`) : domainUrl(`${dbName}${defaultImage.src}`)


    let rightDay = post.published_at ? createRightDate(post.published_at) : createRightDate(post.created_at)

    const content = (
        <>
            <div className={cardClasses}>
                <div className={cls["post-card__image"]}>
                    <Image
                        src={trueImageUrl}
                        alt={post.blog_title}
                        placeholder="blur"
                        layout="fill"
                        priority
                        blurDataURL={`/zega/blur1.webp`}
                    />
                </div>
                <div className={cls["post-card__info"]}>
                    <div className={cls["post-card__name"]}>
                        {/*<span>{post.blog_title.length > 30 ? `${post.blog_title.slice(0, 30)}...` : post.blog_title}</span>*/}
                        <span>{forBLogType === "blog" ? post.blog_title : post.name}</span>
                    </div>
                    <div className={cls["post-card__read-data"]}>
                        <div className={cls["post-card__date"]}>{rightDay}</div>
                        <div className={cls["post-card__read-more"]}>
                            {translationsData.ReadMore}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

    const exactUrl = forBLogType === "blog"
        ? `/blog/${post.url_key}`
        : `/post/${post.slug}`

    return (
        <Link href={exactUrl}>
            <a>{content}</a>
        </Link>
    );
}

export default PostCard;
